import type { ApiClient } from "@/lib/api";
import type { UserSourceCreateRequest } from "../types";

export const createUserSource = async ({
  client,
  payload,
}: {
  client: ApiClient;
  payload: UserSourceCreateRequest;
}) => {
  const { data } = await client.post("/user_sources", payload);
  return data;
};
